module.exports = new __parcel__URL__("voices.a2e50ec1.jpg").toString();